import axios from 'axios'
import { getAuthenticationToken } from '../utils/token'

export default function configureAxiosSetting() {
  const auth = getAuthenticationToken();
  if(auth) {
    axios.defaults.headers.common['Authorization'] = getAuthenticationToken()
  }
}



// WEBPACK FOOTER //
// ./src/api/apiConfiguration.js